module.exports = __webpack_public_path__ + "static/media/up-green.37872cef.svg";